import { DatePicker, Dropdown, Menu } from "antd";
import React, { FC, useRef, useState } from "react";
import EventCalendarPreview from "./EventCalendarPreview";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { GET_USER_SCHEDULE } from "reducers/authReducer";
import { RootState } from "reducers/rootReducer";
import CalendarModal from "../components/Modals/CalendarModal";
const menu = (
  <React.Fragment>
    {/* <Menu.Item> */}
      {/* <div className="site-calendar-demo-card">
          <EventCalendarPreview />
      </div> */}
    {/* </Menu.Item> */}
  </React.Fragment>
);

const Clock: FC<{ theme?: any }> = ({ theme }) => {
  // For digital clock
  const [open, setOpen] = useState<boolean>(false);
  let [ctime, setCTime] = useState<string>();
  const date = useRef();
  const dispatch = useDispatch();


  let time: string = new Date().toLocaleTimeString();
  const updateTime = () => {
    time = new Date().toLocaleTimeString();
    setCTime(time);
  };

  setInterval(updateTime, 1000);

  return (
    <div className="clock">
      {/* <Dropdown overlay={menu} placement="bottomLeft" trigger={["click"]} visible={open} arrow> */}
        <span style={{cursor: 'pointer'}} onClick={() => {
          if(!open){
            dispatch(GET_USER_SCHEDULE());
          }
          setOpen(!open)
        }}>{ctime}</span>
      {/* </Dropdown> */}

      {open &&
        <CalendarModal onClose={()=>{setOpen(false)}}/>
      }
    </div>
  );
}
export default Clock;
